import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { Toolkit } from "./components/sections/Toolkit";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { Problems } from "./components/sections/Problems";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { Commitment } from "./components/sections/Commitment";
import { Testimonials } from "./components/sections/Testimonials";
import { Author } from "./components/sections/Author";
import { FAQ } from "./components/sections/FAQ";
import { FinalCTA } from "./components/sections/FinalCTA";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream" data-id="element-0" data-mp="3ikqy1x7ax04o">
      <MetaPixel data-id="element-1" data-mp="3mlj98vzqhf3l" />
      <Hero data-id="element-2" data-mp="3ml12h5fg3ihf" />
      <main data-id="element-3" data-mp="3mkhlbqxmcy4g">
        <Toolkit data-id="element-4" data-mp="3mk84asujy1aw" />
        <BeforeAfter data-id="element-5" data-mp="3mjq3rk0ux0x6" />
        <Problems data-id="element-6" data-mp="3rc9em985thya" />
        <Volumes data-id="element-7" data-mp="3rbr9so7flver" />
        <Tools data-id="element-8" data-mp="3rdaquh0wwahl" />
        <Bonuses data-id="element-9" data-mp="3rdkkqfp2v1sk" />
        <Offer data-id="element-10" data-mp="3rd17vdeab3le" />
        <Commitment data-id="element-11" data-mp="3relvsk63foaa" />
        <Testimonials data-id="element-12" data-mp="6hqtghuuhen" />
        <Author data-id="element-13" data-mp="4wx1t3d72hu" />
        <FAQ data-id="element-14" data-mp="5ggje8nxyxz" />
        <FinalCTA data-id="element-15" data-mp="82lr78302d1" />
      </main>
      <Footer data-id="element-16" data-mp="2zld0746gb58w" />
      <FloatingCTA data-id="element-17" data-mp="2zlv6ktmtuzuj" />
      <PurchasePopup data-id="element-18" data-mp="2zmeowbge3q93" />
    </div>;
}